import React from 'react';
import PropTypes from 'prop-types';
import NriJournalistBanner from 'components/NriJournalistBanner';
// import CricketScoreWidgetLoader from 'components_v2/common/CricketScoreWidget/CricketScoreWidgetLoader';
import Link from 'components/Link';
import TimesTop10Loader from 'components/TimesTop10/TimesTop10Loader';
import Covid19 from 'components/Covid19SubscriptionWdt';
import Banner from 'components/Banner';
import IFrameWdt from 'components_v2/common/IFrameWdt';
import CardList from 'components_v2/common/CardList';
import PollWidget from 'components_v2/common/PollWidget';
import ElectionStates from 'components_v2/elections/ElectionStates';
import SingleCardSlider from '../SingleCardSlider';
import Listingheader from '../../common/Listingheader';
import RenderAds from '../RenderAds';
import Accordion from '../Accordion/Accordion';
import s from '../../../Home.scss';
// import FakeNews from '../../../../../components_v2/common/FakeNews/FakeNews';
import LoadableComponentLoader from '../../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';
import Market from '../../../../newslisting/components/common/MarketSnapshot';

class RenderInserts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fallbacks: {},
    };
  }

  setFallback = (tn, index, enableFallback) => {
    this.setState({
      fallbacks: {
        ...this.state.fallbacks,
        [`${tn}_${index}`]: enableFallback,
      },
    });
  };

  render() {
    const { data } = this.props;
    if (data && data instanceof Array) {
      return data.map((item, index) => {
        if (
          item.fallback &&
          ((!item.clientSide && !item.data) ||
            this.state.fallbacks[`${item.tn}_${index}`])
        ) {
          // eslint-disable-next-line no-param-reassign
          item = item.fallback;
        }
        switch (item.tn) {
          case 'iframe':
            return <IFrameWdt {...item} key={item.tn} lazy />;
          case 'html':
            return (
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: item.html || '',
                }}
                className={item.globalStyles || ''}
              />
            );
          case 'banner': {
            return (
              <Banner
                imageUrl={item.image && item.image.src ? item.image.src : ''}
                link={item.link}
                gaData={item.ga}
                altTag="Mask India"
                wrapperClassName={s.maskindiabanner}
              />
            );
          }

          case 'covid19wdt':
            return (
              <Covid19
                view="HOME"
                key={item.tn}
                setFallback={enableFallback => {
                  this.setFallback(item.tn, index, enableFallback);
                }}
              />
            );
          case 'NriJournalistBanner':
            return (
              <NriJournalistBanner
                data={item}
                newga={this.props.newga}
                key={item.tn}
              />
            );
          case 'timestopten':
            return (
              <TimesTop10Loader
                inUshome
                setFallback={enableFallback => {
                  this.setFallback(item.tn, index, enableFallback);
                }}
              />
            );
          case 'list':
            return (
              <div className={`${'grid_wrapper'}`} key={`${item.tn}_${index}`}>
                <CardList
                  data={item.data}
                  nonFeaturedItemWrapperClass={`${'col_l_6'} ${'col_m_6'}`}
                  newga="SportsSection_Actions#SportsClick-"
                  imgWidth="200"
                />
              </div>
            );
          case 'poll':
            return (
              <PollWidget
                {...item}
                hideShareFeature
                key={`${item.tn}_${index}`}
                isLoggedIn={this.props.isLoggedIn}
                toggleLoginBox={this.props.toggleLoginBox}
                ga4Type={item?.ga4Type}
                ga4Category={item?.ga4Category}
              />
            );
          case 'column_1_list':
            return (
              <div
                className={`${'grid_wrapper gadget_review'} ${s.rhs_col}`}
                key={`${item.tn}_${index}`}
              >
                {item.name || item.link ? (
                  <Listingheader
                    headingname={item.name}
                    headingLink={item.link}
                    size="small"
                    newga={`${item.name}Section_Actions#${
                      item.name
                    }_HeadingClick`}
                  />
                ) : null}
                <CardList
                  data={item.data}
                  nonFeaturedItemWrapperClass={`${s.paddingBottom12} ${
                    s.paddingTop12
                  } noBorder ${'col_l_12'} ${'col_m_12'}`}
                  nonFeaturedListTileType="defaultTile"
                  newga={`${item.gaName ||
                    item.name}Section_Actions#${item.gaName ||
                    item.name}Click-`}
                  imgWidth="100"
                />
              </div>
            );
          case 'row_1_news_list':
            return (
              <div className="row-news-list">
                {item &&
                  item.data &&
                  item.data.map(row => (
                    <Link
                      key={row.id}
                      to={row.wu}
                      className="linktype1"
                      //data-newga={`TopSection-Actions#TopClick-Grid3/${index}/${item.wu}`}
                    >
                      <span>{row.hl}</span>
                      {row.type === 'photostory' ? (
                        <i className="icon photos" />
                      ) : null}
                      {row.type === 'video' ? (
                        <i className="icon videos" />
                      ) : null}
                    </Link>
                  ))}
              </div>
            );
          case 'col_1_news_list':
            return (
              <div className={this.props.col1NewsListClass}>
                <CardList
                  data={item.data}
                  showDescription
                  nonFeaturedItemWrapperClass="col_l_6 col_m_6 bdr_right no_bdr_last"
                  itemClass="linktype2"
                  nonFeaturedListWrapperClass="grid_wrapper"
                  // newga={`${sectionData.name}Section_Actions#${
                  //   sectionData.name
                  // }Click-`}
                  htmlKeys={item.htmlKeys}
                  key={`${item.id}_${item.tn}`}
                />
              </div>
            );
          case 'accordion':
            return (
              <div className={s.accordionBlock} key={item.tn}>
                <Listingheader
                  headingname={item.name}
                  headingLink={item.link}
                  size="small"
                  newga={`${this.props.newga}/${item.name}_HeadingClick`}
                />
                <Accordion data={item.data} newga={this.props.newga} />
              </div>
            );
          case 'cricketscorewidget':
            // cricketscorewidget to be handled in another release
            this.setFallback(item.tn, index, true);
            return null;
          case 'slider':
            if (this.props.showToiPlusEntryPoints) {
              return (
                <SingleCardSlider
                  data={item.data}
                  nonFeaturedItemWrapperClass={`${'col_l_4'} ${'col_m_4'}`}
                  // newga="SportsSection_Actions#SportsClick-"
                  imgWidth="200"
                  isPrime={this.props.isPrime}
                />
              );
            }
            return null;
          case 'ad':
            return (
              <RenderAds
                adObject={item}
                addMarginTop={this.props.addMarginTop}
                lazyload={this.props.lazyload}
                key={`${item.tn}_${index}`}
                isWapView={this.props.isWapView}
                adWrapperClass={this.props.adWrapperClass}
              />
            );
          case 'keystates':
            return <ElectionStates item={item} key={`${item.tn}_${index}`} />;
          case 'fake_news':
            return (
              <ErrorBoundary>
                <div className={s.fakenews_wrapper}>
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="FakeNews"
                    data={item}
                  />
                </div>
              </ErrorBoundary>
            );
          case 'goldSilver':
            return (
              <ErrorBoundary>
                <Market data={item} />
              </ErrorBoundary>
            );
          default:
            return null;
        }
      });
    }
    return null;
  }
}

RenderInserts.propTypes = {
  data: PropTypes.shape({}).isRequired,
  addMarginTop: PropTypes.bool,
  lazyload: PropTypes.bool,
  newga: PropTypes.string,
  col1NewsListClass: PropTypes.bool,
  isWapView: PropTypes.bool,
  adWrapperClass: PropTypes.shape({}),
  showToiPlusEntryPoints: PropTypes.bool,
};

RenderInserts.defaultProps = {
  addMarginTop: false,
  lazyload: false,
  newga: '',
  col1NewsListClass: false,
  isWapView: false,
  adWrapperClass: undefined,
  showToiPlusEntryPoints: false,
};

export default RenderInserts;
